import { Accordion, Stack, Text } from '@mantine/core';
import { StepType } from '@/types/automationFields.ts';
import useRetrieveAutomationCapabilities from '@/hooks/api/steps/useRetrieveAutomationCapabilities.ts';

type Props = { stepType: StepType };

function ReferenceDetail({ label, children }: { label: string; children: string }) {
  return (
    <Stack gap={2}>
      <Text size="11px" fw={600} c="dimmed" tt="uppercase">
        {label}
      </Text>
      <Text size="12px">{children}</Text>
    </Stack>
  );
}

/** Concise, source-backed orientation material for the current step type. */
const StepReferencePanel = ({ stepType }: Props) => {
  const { data } = useRetrieveAutomationCapabilities(stepType);
  const capability = data?.steps.find((step) => step.id === stepType);
  if (!capability) return null;

  return (
    <Accordion variant="contained">
      <Accordion.Item value="step-reference">
        <Accordion.Control>
          <Text size="13px" fw={600}>
            Step reference
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Stack gap="sm">
            <Stack gap={2}>
              <Text size="12px" fw={600}>
                {capability.summary}
              </Text>
              <Text size="12px" c="dimmed">
                {capability.behavior}
              </Text>
            </Stack>
            <ReferenceDetail label="Output">{capability.output_behavior}</ReferenceDetail>
            <ReferenceDetail label="Validation">{capability.validation_behavior}</ReferenceDetail>
            <ReferenceDetail label="Review">{capability.review_behavior}</ReferenceDetail>
            <ReferenceDetail label="Retry">{capability.retry_behavior}</ReferenceDetail>
            <ReferenceDetail label="Side effects">{capability.side_effects}</ReferenceDetail>
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default StepReferencePanel;
